import { AccountingColumnCodeToDatabaseColumn } from "~/pages/Accounting/AccountingPeriod/AccountingTable/options";

export const REPORT_COLUMN_CODES = [
  "_MTExMA__",
  "_MTEyMA__",
  "_MTEzMA__",
  "_MTE0MA__",
  "_MTE1MA__",
  "_MTE1MQ__",
  "_MTE1MS8x",
  "_MTE1MS8y",
  "_MTE1Mg__",
  "_MTE1Mi8x",
  "_MTE1Mi8y",
  "_MTE1Mw__",
  "_MTE1My8x",
  "_MTE1My8y",
  "_MTE1NA__",
  "_MTE1NC8x",
  "_MTE1NC8y",
  "_MTE2MA__",
  "_MTE3MA__",
  "_MTE3MQ__",
  "_MTE4MA__",
  "_MTE5MA__",
  "_MTE5MQ__",
  "_MTEwMA__",
  "_MTIxMA__",
  "_MTIxMQ__",
  "_MTIxMg__",
  "_MTIxMw__",
  "_MTIxNA__",
  "_MTIyMA__",
  "_MTIzMA__",
  "_MTIzMQ__",
  "_MTIzMg__",
  "_MTIzMw__",
  "_MTIzNA__",
  "_MTI0MA__",
  "_MTI1MA__",
  "_MTI2MA__",
  "_MTIwMA__",
  "_MTYwMA__",
  "_MTMxMA__",
  "_MTMyMA__",
  "_MTM0MA__",
  "_MTM1MA__",
  "_MTM2MA__",
  "_MTM3MA__",
  "_MTMwMA__",
  "_MTQxMA__",
  "_MTQyMA__",
  "_MTQzMA__",
  "_MTQ1MA__",
  "_MTQwMA__",
  "_MTUxMA__",
  "_MTUyMA__",
  "_MTUyMQ__",
  "_MTUyMg__",
  "_MTUyMw__",
  "_MTUzMA__",
  "_MTU0MA__",
  "_MTU1MA__",
  "_MTUwMA__",
  "_MjAwMA__",
  "_MjExMA__",
  "_MjExMQ__",
  "_MjExMg__",
  "_MjExMw__",
  "_MjExNA__",
  "_MjExNQ__",
  "_MjExNg__",
  "_MjExNw__",
  "_MjExOA__",
  "_MjEyMA__",
  "_MjEyMQ__",
  "_MjEyMg__",
  "_MjEyMw__",
  "_MjEyNA__",
  "_MjEyNQ__",
  "_MjEyNg__",
  "_MjEyNw__",
  "_MjEwMA__",
  "_MjIxMA__",
  "_MjIxMQ__",
  "_MjIxMS8x",
  "_MjIxMS8y",
  "_MjIxMS8z",
  "_MjIxMS80",
  "_MjIxMS81",
  "_MjIxMS82",
  "_MjIxMS83",
  "_MjIxMS84",
  "_MjIxMg__",
  "_MjIxMw__",
  "_MjIyMA__",
  "_MjIyMC8x",
  "_MjIyMC8y",
  "_MjIyMC8z",
  "_MjIyMC80",
  "_MjIyMC81",
  "_MjIyMC82",
  "_MjIyMC83",
  "_MjIyMC84",
  "_MjIyMC85",
  "_MjIyMC8xMA__",
  "_MjIyMC8xMQ__",
  "_MjIwMA__",
  "_MjMxMA__",
  "_MjMyMA__",
  "_MjMzMA__",
  "_MjM0MA__",
  "_MjM0MQ__",
  "_MjM0Mg__",
  "_MjM0Mw__",
  "_MjM1MA__",
  "_MjMwMA__",
  "_MjQxMA__",
  "_MjQyMQ__",
  "_MjQzMA__",
  "_MjQ1MA__",
  "_MjQ2MA__",
  "_MjQwMA__",
  "_MjUxMA__",
  "_MjUyMA__",
  "_MjUwMA__",
  "_MjkxMA__",
  "_MjkwMA__",
];

export const REPORT_COLUMN_CODES_FORM2 = [
  AccountingColumnCodeToDatabaseColumn("2110"),
  AccountingColumnCodeToDatabaseColumn("2111"),
  AccountingColumnCodeToDatabaseColumn("2112"),
  AccountingColumnCodeToDatabaseColumn("2113"),
  AccountingColumnCodeToDatabaseColumn("2114"),
  AccountingColumnCodeToDatabaseColumn("2115"),
  AccountingColumnCodeToDatabaseColumn("2116"),
  AccountingColumnCodeToDatabaseColumn("2117"),
  AccountingColumnCodeToDatabaseColumn("2118"),
  AccountingColumnCodeToDatabaseColumn("2120"),
  AccountingColumnCodeToDatabaseColumn("2121"),
  AccountingColumnCodeToDatabaseColumn("2122"),
  AccountingColumnCodeToDatabaseColumn("2123"),
  AccountingColumnCodeToDatabaseColumn("2124"),
  AccountingColumnCodeToDatabaseColumn("2125"),
  AccountingColumnCodeToDatabaseColumn("2126"),
  AccountingColumnCodeToDatabaseColumn("2127"),
  AccountingColumnCodeToDatabaseColumn("2100"),
  AccountingColumnCodeToDatabaseColumn("2210"),
  AccountingColumnCodeToDatabaseColumn("2211"),
  AccountingColumnCodeToDatabaseColumn("2211/1"),
  AccountingColumnCodeToDatabaseColumn("2211/2"),
  AccountingColumnCodeToDatabaseColumn("2211/3"),
  AccountingColumnCodeToDatabaseColumn("2211/4"),
  AccountingColumnCodeToDatabaseColumn("2211/5"),
  AccountingColumnCodeToDatabaseColumn("2211/6"),
  AccountingColumnCodeToDatabaseColumn("2211/7"),
  AccountingColumnCodeToDatabaseColumn("2211/8"),
  AccountingColumnCodeToDatabaseColumn("2212"),
  AccountingColumnCodeToDatabaseColumn("2213"),
  AccountingColumnCodeToDatabaseColumn("2220"),
  AccountingColumnCodeToDatabaseColumn("2220/1"),
  AccountingColumnCodeToDatabaseColumn("2220/2"),
  AccountingColumnCodeToDatabaseColumn("2220/3"),
  AccountingColumnCodeToDatabaseColumn("2220/4"),
  AccountingColumnCodeToDatabaseColumn("2220/5"),
  AccountingColumnCodeToDatabaseColumn("2220/6"),
  AccountingColumnCodeToDatabaseColumn("2220/7"),
  AccountingColumnCodeToDatabaseColumn("2220/8"),
  AccountingColumnCodeToDatabaseColumn("2220/9"),
  AccountingColumnCodeToDatabaseColumn("2220/10"),
  AccountingColumnCodeToDatabaseColumn("2220/11"),
  AccountingColumnCodeToDatabaseColumn("2200"),
  AccountingColumnCodeToDatabaseColumn("2310"),
  AccountingColumnCodeToDatabaseColumn("2320"),
  AccountingColumnCodeToDatabaseColumn("2330"),
  AccountingColumnCodeToDatabaseColumn("2340"),
  AccountingColumnCodeToDatabaseColumn("2341"),
  AccountingColumnCodeToDatabaseColumn("2342"),
  AccountingColumnCodeToDatabaseColumn("2343"),
  AccountingColumnCodeToDatabaseColumn("2350"),
  AccountingColumnCodeToDatabaseColumn("2300"),
  AccountingColumnCodeToDatabaseColumn("2410"),
  AccountingColumnCodeToDatabaseColumn("2421"),
  AccountingColumnCodeToDatabaseColumn("2430"),
  AccountingColumnCodeToDatabaseColumn("2450"),
  AccountingColumnCodeToDatabaseColumn("2460"),
  AccountingColumnCodeToDatabaseColumn("2400"),
  AccountingColumnCodeToDatabaseColumn("2510"),
  AccountingColumnCodeToDatabaseColumn("2520"),
  AccountingColumnCodeToDatabaseColumn("2500"),
  AccountingColumnCodeToDatabaseColumn("2910"),
  AccountingColumnCodeToDatabaseColumn("2900"),
];
